import React from 'react';

import { CellRendererProps } from '../../DataTable.types';

import StatusDropdown, { StatusDropdownOption } from '../../../StatusDropdown/StatusDropdown';
import { Handlers } from '../../../../../types/actions/types';
import { fallbackDealStatusOption } from '../../../../../modules/Investor/Deals/components/DealsList/constants';
import { getHorizontalLabelId } from '../../DataTable.constants';

export interface UpdateSingleSelectDropdownProps {
    row?: any;
    column?: any;
    option?: any;
    deal?: any;
    handlers?: Handlers;
}

export const SingleSelectDropdownCellRenderer: React.FC<CellRendererProps> = ({ value, row, column, dynamicProps }) => {
    const { dropdownOptions } = column;
    const {
        updateSingleSelectDropdown,
        isPartner,
        getStatusDropdownList,
        setSelectedDropdownOption,
        isDisabled,
        isConfigTableModalDropDown,
        fieldVariant,
    } = dynamicProps ?? {};
    const dropdownOptionsFromProps = getStatusDropdownList?.(column, row) ?? null;
    const finalDropdownOptions = dropdownOptionsFromProps || dropdownOptions;

    if (!finalDropdownOptions) return null;

    if (!updateSingleSelectDropdown) {
        console.warn('SingleSelectDropdownCellRenderer: updateSingleSelectDropdown function not provided');
        return null;
    }

    let selectedOption = finalDropdownOptions?.[value] || fallbackDealStatusOption['Select'];

    const overrideOption = setSelectedDropdownOption?.(row, column);

    if (overrideOption !== null && overrideOption !== undefined) {
        selectedOption = overrideOption;
    }

    return (
        <StatusDropdown
            dropdownOptions={Array.isArray(finalDropdownOptions) ? finalDropdownOptions : Object.values(finalDropdownOptions)}
            selectedOption={selectedOption}
            showClearButton={column?.showClearSelection ?? true}
            restrictBackwardMovement={column?.restrictBackwardMovement || false}
            selectOption={(option: StatusDropdownOption) => {
                const params: UpdateSingleSelectDropdownProps = {
                    row,
                    column,
                    deal: dynamicProps?.deal,
                    option,
                };

                updateSingleSelectDropdown(params);
            }}
            disabled={isPartner || isDisabled}
            field={column?.field}
            isConfigTableModalDropDown={isConfigTableModalDropDown}
            fieldVariant={fieldVariant}
            labelledBy={fieldVariant ? getHorizontalLabelId(column?.field) : undefined}
            row={row}
        />
    );
};
